var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpand5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33008 6.33032C5.33008 5.77804 5.77779 5.33032 6.33008 5.33032H11.668C12.2203 5.33032 12.668 5.77804 12.668 6.33032V11.6682C12.668 12.2205 12.2203 12.6682 11.668 12.6682H6.33008C5.77779 12.6682 5.33008 12.2205 5.33008 11.6682V6.33032Z",
    stroke: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.002 3.99621L16.6703 1.32788",
    stroke: "#909090"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 16.6708L3.99646 14.0024",
    stroke: "#909090"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66354 16.6709H1.32812V13.3354",
    stroke: "#909090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6714 4.6633V1.32788H13.3359",
    stroke: "#909090"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.002 14.0012L16.6703 16.6709",
    stroke: "#909090"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 1.32788L3.99646 3.99621",
    stroke: "#909090"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32812 4.6633V1.32788H4.66354",
    stroke: "#909090"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3359 16.6709H16.6714V13.3354",
    stroke: "#909090"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand5);
export default __webpack_public_path__ + "static/media/expand-5.48d98db6385650ad82a4cae84d97adb3.svg";
export { ForwardRef as ReactComponent };